<input type="text" style="width:200px;"    (keydown)="onKeyDown($event)"/>